import heroSwiper from './modules/heroSwiper.js';
import heroPopups from './modules/heroPopups.js';

document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector(".hero__popup")) {
        heroPopups();
    }
});